<template>
  <button
    class="c-engraving-keyboard-key l-grid l-grid__item--align-center"
    @mouseleave="toggleShow"
    @mouseenter="toggleShow"
    @click="buttonClick"
  >
    <div
      v-if="showOnHover"
      class="c-engraving-keyboard-key__key-description"
    >
      {{ symbolName }}
    </div>
    <span :style="'font-family:' + font + ';'">{{ symbol }}</span>
  </button>
</template>
<script>

export default {
  props:{
    symbol:{
      type: String,
      default:''
    },
    symbolName:{
      type:String,
      default:''
    },
    font:{
      type:String,
      default:''
    },
    type: {
      type: String,
      default: 'rectangle'
    }
  },
  data(){
    return{
      showOnHover: false,
    }
  },
  methods:{
    toggleShow(){
      this.showOnHover = !this.showOnHover;
    },
    buttonClick(){
      this.$emit('buttonClick', this.symbol)
    }
  },
}
</script>
<style lang="scss" scoped>
 .c-engraving-keyboard-key{
   @include buttonReset;

    position:relative;
    text-align: center;
    width: rem(45px);
    height: rem(45px);
    border-radius: 100%;
    margin: rem(10px) rem(20px) rem(10px) 0;
    background: transparent;
    cursor: pointer;
    @include themify($themes) {
      border: 1px solid themed("foreground", "select");
    }

	&__key-description{
		position: absolute;
		top: rem(-15px);
    left: 50%;
    transform: translate(-50%, -50%);
		background-color: #022840;
		color: #fff;
		padding:rem(3px);
		border-radius: 4px;
		width: max-content;
    text-overflow: ellipsis;
	}
 }
</style>